/**
 *
 * 虚线框
 */

export default {
  style: {
    default: {
      fill: '#FFFFFF',
      fillOpacity: 1,
      stroke: '#1890FF',
      strokeOpacity: 1,
      lineDash: [ 5, 5 ]
    }
  }
}
